import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { SupervisoryReviewQuestionnaireItem } from './questionnaire'

export const SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EMPLOYEE]:
    QuestionnaireAnswerType.REFERENCE,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_SUPERVISION_OBSERVED]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_ID_BADGE]: QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_HONORING_RIGHTS]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_REPORTING_CHANGES]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_PPE_ACCESS]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION]: QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_VERBALLY_UNDERSTOOD]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_REPEATED_BACK]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_DEMONSTRATED_SKILL_CORRECTNESS]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_DOCUMENTATION]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_ADHERED_TO_CARE_PLAN]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_PROFESSIONALISM]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_SATISFACTION]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_COMMENTS]: QuestionnaireAnswerType.STRING
}
